module.exports = __webpack_public_path__ + "static/media/banner1.ca942ad9.jpg";